import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Card,
  Table,
  Button,
  ProgressBar,
  Badge,
} from "react-bootstrap";
import {
  IconCloudUpload,
  IconFileText,
  IconChevronRight,
  IconUpload,
  IconArrowRight,
  IconCloudUp,
} from "@tabler/icons-react";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DynamicPagination from "../../components/DynamicPagination ";
import moment from "moment";

function FBOPListing() {
  // 1. State for managing selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [uploadFiles, setUploadFiles] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const navigate = useNavigate();
  const { data: documentData, postData: fetchData } = usePostRequest(
    API_ENDPOINTS.FBOP_LISTING
  );

  const { isLoading: uploading, postData: uploadPdf } = usePostRequest(
    API_ENDPOINTS.UPLOAD_PDF
  );

  // Mock data for the table
  // const documentData = [
  //   { id: 1, name: "Aspetto Male Sizing Form", pageCount: 50, processed: 20 },
  //   { id: 2, name: "Aspetto Female Sizing Form", pageCount: 5, processed: 3 },
  //   { id: 3, name: "Aspetto Male Sizing Form", pageCount: 22, processed: 18 },
  // ];

  console.log("documentData", documentData);

  useEffect(() => {
    const payload = { page: page, limit: limit };
    fetchData(payload);
    setUploadingFiles(false);
  }, [page, limit, uploadingFiles]);

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
  };

  // Handler for file selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleClearAll = () => {
    setSelectedFiles([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleStartProcessing = async () => {
    if (!selectedFiles.length) return;

    const formData = new FormData();

    // If backend expects multiple files
    // selectedFiles.forEach((file) => {
    //   formData.append("files[]", file);
    // });

    // OR if backend expects single file per request:
    formData.append("file", selectedFiles[0]);

    // await uploadPdf(formData);
    await uploadPdf(formData, onSuccessUpload, onErrorUpload);
  };

  const onSuccessUpload = (response) => {
    toast.success(response?.message || "File uploaded successfully!");
    // Clear UI after upload
    setSelectedFiles([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setUploadingFiles(true);
    setUploadFiles(false);
  };

  const onErrorUpload = (error) => {
    toast.error(error?.message || "Error uploading file.");
    console.error("Upload Error:", error);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    // fetchData(false, API_ENDPOINTS.FBOP_LISTING + `?page=${newPage}`);
  };

  return (
    <div
      style={{
        // backgroundColor: "#f8f9fa",
        backgroundColor: "white",
        minHeight: "100vh",
        paddingBottom: "3rem",
      }}
    >
      <Container className="pt-4">
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div>
            <h3 className="fw-bold mb-1" style={{ color: "#191d26" }}>
              FBOP Management
            </h3>
            <p className="text-muted">
              Manage and review your AI-processed sizing forms.
            </p>
          </div>
          <Button
            className="d-flex align-items-center gap-2 px-4 py-2"
            style={{
              backgroundColor: "#FE6338",
              border: "none",
              borderRadius: "8px",
            }}
            onClick={() => setUploadFiles(true)}
          >
            <IconCloudUpload size={20} /> <strong> Upload New PDF</strong>
          </Button>
        </div>
        {(uploadFiles || documentData?.data?.length === 0) && (
          <Card
            className="border-0 shadow-sm mb-4"
            style={{ borderRadius: "20px", padding: "40px 0" }}
          >
            <div
              className="w-50 d-flex flex-column align-items-center justify-content-center m-0 m-auto"
              style={{
                border: "2px dashed #dee2e6",
                margin: "0 30px",
                borderRadius: "20px",
                padding: "40px",
              }}
            >
              <div className="mb-3">
                <IconCloudUp size={40} color="#6C7A91" />
              </div>
              <h5 className="fw-bold mb-1">Click or drag PDF files here</h5>
              <p className="text-muted small mb-4">
                Supports multiple files (Max 20MB each)
              </p>

              <input
                type="file"
                multiple
                accept=".pdf"
                hidden
                ref={fileInputRef}
                onChange={handleFileChange}
              />
              <Button
                onClick={handleBrowseClick}
                style={{
                  backgroundColor: "#191d26",
                  border: "none",
                  padding: "10px 30px",
                  borderRadius: "8px",
                  fontWeight: "bold",
                }}
              >
                Browse Files
              </Button>
            </div>
            {selectedFiles.length > 0 && (
              <div className="w-50 m-0 m-auto mt-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <h6 className="mb-0 fw-bold">
                      Selected Files ({selectedFiles.length})
                    </h6>
                  </div>
                  <Button
                    variant="link"
                    className="text-danger text-decoration-none p-0 fw-bold"
                    onClick={handleClearAll}
                  >
                    Clear All
                  </Button>
                </div>

                {selectedFiles.map((file, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center gap-3 p-3 mb-3"
                    style={{
                      backgroundColor: "#f8faff",
                      borderRadius: "12px",
                      border: "1px solid #edf2f7",
                    }}
                  >
                    <div className="p-2 bg-white border rounded">
                      <IconFileText size={20} color="#adb5bd" />
                    </div>
                    <div>
                      <div
                        className="fw-medium text-dark"
                        style={{ fontSize: "0.9rem" }}
                      >
                        {file.name}
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {(file.size / (1024 * 1024)).toFixed(2)} MB
                      </div>
                    </div>
                  </div>
                ))}

                <Button
                  className="w-100 mt-2 py-3 d-flex align-items-center justify-content-center gap-2"
                  style={{
                    backgroundColor: "#FE6338",
                    border: "none",
                    borderRadius: "12px",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                  }}
                  onClick={handleStartProcessing}
                  disabled={uploading}
                >
                  {uploading ? "Submitting..." : "Submit"}{" "}
                  {!uploading && <IconArrowRight size={20} />}
                </Button>
              </div>
            )}
          </Card>
        )}

        <Card className="shadow-sm">
          <Card.Body className="">
            <div className="table-responsive">
              <Table className="mb-3 align-middle">
                <thead className="bg-light">
                  <tr
                    style={{
                      fontSize: "0.85rem",
                      textTransform: "uppercase",
                      color: "#6c757d",
                    }}
                  >
                    <th className="ps-4 py-3">Sr.</th>
                    <th className="py-3">Attachment Name</th>
                    <th className="py-3">Created Date</th>
                    <th className="py-3">Page Count</th>
                    <th className="py-3" style={{ width: "300px" }}>
                      Extraction Progress
                    </th>
                    <th className="py-3 text-end pe-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {documentData?.data?.map((doc, index) => {
                    const percentage = Math.round(
                      (doc.total_processed_forms / doc.total_forms) * 100
                    );
                    return (
                      <tr key={doc.id} style={{ fontSize: "0.95rem" }}>
                        <td className="ps-4 text-muted">{index + 1}.</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className="p-2 rounded"
                              style={{
                                backgroundColor: "#eef2ff",
                                color: "#FE6338",
                              }}
                            >
                              <IconFileText size={18} />
                            </div>
                            <span
                              className="fw-medium"
                              style={{ color: "#374151" }}
                            >
                              {doc?.file_name}
                            </span>
                          </div>
                        </td>
                        <td className="ps-4 text-muted">{moment(doc?.created_at).format("MM/DD/YYYY HH:mm")}</td>
                        
                        <td>
                          <Badge
                            bg="light"
                            text="dark"
                            className="px-3 py-2 fw-normal border"
                            style={{
                              borderRadius: "20px",
                              fontSize: "0.85rem",
                            }}
                          >
                            {doc?.total_forms} Pages
                          </Badge>
                        </td>
                        <td>
                          <div className="pe-4">
                            <div
                              className="d-flex justify-content-between mb-1"
                              style={{ fontSize: "0.8rem" }}
                            >
                              <span className="text-muted">
                                <span
                                  className="fw-bold"
                                  style={{ color: "#0CA678" }}
                                >
                                  {doc?.total_processed_forms}
                                </span>{" "}
                                / {doc?.total_forms} processed
                              </span>
                              <span className="fw-bold">{percentage}%</span>
                            </div>
                            <ProgressBar
                              now={percentage}
                              style={{
                                height: "6px",
                                backgroundColor: "#e5e7eb",
                              }}
                            />
                          </div>
                        </td>
                        <td className="text-end pe-4">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"
                            style={{
                              fontSize: "0.85rem",
                              borderColor: "#FE6338",
                              color: "#FE6338",
                              backgroundColor: "transparent",
                            }}
                            onClick={() =>
                              navigate(`/fbop-data/${doc.auto_id}`)
                            }
                          >
                            View Results <IconChevronRight size={14} />
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            {documentData?.data?.length > 0 && (
              <DynamicPagination
                totalPages={documentData?.pagination?.totalPages}
                currentPage={page}
                onPageChange={handlePageChange}
                limitPerPage={limit}
                onLimitChange={handleLimitChange}
              />
            )}
          </Card.Body>
        </Card>
      </Container>

      <style>{`
        .progress-bar { background-color: #0CA678 !important; }
        .table tbody tr:hover { background-color: #f9fafb !important; }
      `}</style>
    </div>
  );
}

export default FBOPListing;
